import { inject, Injectable } from '@angular/core';
import { catchError, from, Observable, throwError } from 'rxjs';
import {
  CreateCustomDomain,
  CustomDomain,
  CustomDomainList,
  CustomDomainsApi,
} from '@tourfold/libraries/tf-api-client-frontend-v2';

@Injectable({ providedIn: 'root' })
export class CustomDomainsService {
  private readonly api = inject(CustomDomainsApi);

  list(): Observable<CustomDomainList> {
    return from(this.api.listCustomDomains()).pipe(
      catchError((error: unknown) => {
        return throwError(() => error);
      }),
    );
  }

  create(createCustomDomain: CreateCustomDomain): Observable<CustomDomain> {
    return from(this.api.createCustomDomain({ createCustomDomain })).pipe(
      catchError((error: unknown) => {
        return throwError(() => error);
      }),
    );
  }

  verify(id: string): Observable<CustomDomain> {
    return from(this.api.verifyCustomDomain({ id })).pipe(
      catchError((error: unknown) => {
        return throwError(() => error);
      }),
    );
  }

  remove(id: string): Observable<void> {
    return from(this.api.deleteCustomDomain({ id })).pipe(
      catchError((error: unknown) => {
        return throwError(() => error);
      }),
    );
  }
}
